import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "signal_cellular_alt",
  "use": "signal_cellular_alt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"signal_cellular_alt\">\n<title>signal_cellular_alt</title>\n<path d=\"M11.016 9h3v11.016h-3v-11.016zM5.016 14.016h3v6h-3v-6zM17.016 3.984h3v16.031h-3v-16.031z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol